import React from 'react';
import classNames from 'classnames';

import SVG from 'components/base/SVG';
import { isRedactedNumber } from 'utils/contactUtil';

import emptyContactIllustration from 'assets/images/contact-profile-empty.svg';

import css from './style.scss';

/** Contact Information card: phones/emails when present, otherwise the Skip
 *  Trace banner (existing contact) or the add-details empty state (new one). */
const ContactInfoCard = ({
  contact,
  isNewContact,
  isSaved,
  showContactInfo,
  skipTracing,
  propertyAddress,
  mailingAddress,
  onEdit,
  onSkipTrace,
  MailingAddress,
  canDial,
  onDialPhone,
}) => (
  <section className={css.infoCard}>
    <div className={css.infoHeader}>
      <div className={css.infoTitle}>Contact Information</div>
      <button
        type="button"
        className={css.btnOutline}
        disabled={!isSaved}
        title={isSaved ? undefined : 'Save the name and company first'}
        onClick={onEdit}
      >
        <SVG icon="cp-edit" className={css.btnOutlineIcon} />
        Edit
      </button>
    </div>

    {showContactInfo ? (
      <div className={css.infoBody}>
        {!contact.phones?.length ? null : (
          <div className={css.infoLine}>
            <SVG icon="cp-call" className={css.callIcon} />
            <div className={css.infoLineValues}>
              {contact.phones.map((p, idx) => {
                const dialable = canDial && !isRedactedNumber(p.phone);
                return (
                  <span className={css.infoValue} key={p.seq ?? idx}>
                    <span
                      className={classNames(css.infoLink, { [css.infoLinkDial]: dialable })}
                      onClick={dialable ? () => onDialPhone(p) : undefined}
                    >
                      {p.phone}
                    </span>
                    {p.publicDNC ? <span className={css.dncPill}>DNC</span> : null}
                    {idx < contact.phones.length - 1 ? <span>,</span> : null}
                  </span>
                );
              })}
            </div>
          </div>
        )}

        {!contact.emails?.length ? null : (
          <div className={css.infoLine}>
            <SVG icon="cp-mail" className={css.mailIcon} />
            <div className={css.infoLineValues}>
              {contact.emails
                .map((e) => e.email)
                .filter(Boolean)
                .join(', ')}
            </div>
          </div>
        )}
      </div>
    ) : (
      <div className={css.infoBody}>
        {isNewContact ? (
          <div className={css.emptyAdd}>
            <img className={css.emptyAddArt} src={emptyContactIllustration} alt="" />
            <div className={css.emptyAddText}>
              <div className={css.emptyAddCopy}>
                Add contact details, including phone numbers, emails, and addresses.
              </div>
              <button
                type="button"
                className={css.btnAddDetails}
                disabled={!isSaved}
                title={isSaved ? undefined : 'Save the name and company first'}
                onClick={onEdit}
              >
                Add Contact Details
              </button>
            </div>
          </div>
        ) : (
          <div className={css.skipTraceBanner}>
            <div>
              <div className={css.skipTraceTitle}>Contact Information</div>
              <div className={css.skipTraceCopy}>
                Access the contact information for this contact at no cost.
              </div>
            </div>
            <button
              type="button"
              className={css.btnSkipTrace}
              disabled={skipTracing}
              onClick={onSkipTrace}
            >
              {skipTracing ? (
                <SVG icon="spinner" className={css.skipTraceIcon} />
              ) : (
                <SVG icon="cp-skip-trace" className={css.skipTraceIcon} />
              )}
              Skip Trace
            </button>
          </div>
        )}
      </div>
    )}

    <div className={css.infoDivider} />

    <MailingAddress propertyAddress={propertyAddress} mailingAddress={mailingAddress} />
  </section>
);

export default ContactInfoCard;
